<template>
  <div class="services">
    <mainPage :menus="menus" 
              pageTitle="综合服务"
              :propActiveMenu="activeMenu"
              @handleMainMenu="handleMainMenu">
      <div v-if="!news.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
      <div v-for="(item, i) in news" :key="i" class="services_item flex-width">
        <div class="cover">
          <img :src="item.coverImage" alt="">
        </div>
        <div class="content">
          <div class="title" @click="detailInfo(item)">{{item.title}}</div>
          <div class="label" v-if="item.tags">{{item.tags}}</div>
          <div class="desc">{{item.summary}}</div>
          <div class="date">发布时间：{{item.createTime}}</div>
          <div class="btn" @click="detailInfo(item)">
            了解详情 <i class="iconfont icon-jiantou"></i>
          </div>
        </div>
      </div>
      <el-pagination
        background
        :page-size="pageSize"
        :page-count="pageCount"
        layout="prev, pager, next, total"
        :total="5"
        style="text-align: center">
      </el-pagination>
    </mainPage>
  </div>
</template> 

<script>
import mainPage from './layout/main-page'

export default {
  name: 'services',
  components: { 
    mainPage
  },
  data () {
    return {
      pageCount: 1,
      pageSize: 5,
      activeMenu: 6,
      menus: [
        {value: 6, label: '经贸促进'},
        {value: 7, label: '信息服务'},
        {value: 8, label: '商事法律服务'},
        {value: 9, label: '规则标准推广'},
      ],
      news: [],
    }
  },
  filters: {
  },
  computed: {
    localeLang: {
      get () { return this.$store.state.common.localeLang },
    }
  },
  watch: {
  },
  mounted () {
    this.handleMainMenu()
  },
  methods: {
    detailInfo (item) {
      const routeUrl = this.$router.resolve({
        path: '/info',
        query: {id: item.id}
      })
      window.open(routeUrl.href, '_blank')
    },
    handleMainMenu (val) {
      if (val) this.activeMenu = val.value
      this.loadState = true
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/contentManagement/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 5,
          data: {
            contentType: this.activeMenu, // 新闻动态
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.news = res.data.result.list || []
        }
      }).finally(() => {
        this.loadState = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.services{
  .services_item{
    display: flex;
    margin-bottom: 40px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    .cover{
      width: 50%;
      height: 320px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .content{
      flex: 1;
      padding: 30px;
      .title{
        font-size: 22px;
        font-weight: bold;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        margin-bottom: 20px;
      }
      .label{
        background: #e9edf6;
        color: #4070b2;
        display: inline-block;
        padding: 4px 10px;
        margin-bottom: 20px;
      }
      .date{
        color: #999;
        margin: 14px 0;
        font-size: 14px;
      }
      .desc{
        color: #444444;
        font-size: 16px;
        line-height: 28px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
      .btn{
        float: right;
        color: #386bb1;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/services.vue